import type { ReactNode } from 'react';

type DataColumn<T extends object, K extends keyof T = keyof T> = {
    title: string;
    dataProperty: K;
    render?: (value: T[K], entity: T) => ReactNode;
};

type KeyColumn<T extends object> = {
    title: string;
    key: string;
    render: (_: unknown, entity: T) => ReactNode;
};

export type TColumn<T extends object> = DataColumn<T> | KeyColumn<T>;

export const isDataColumn = <T extends object>(column: TColumn<T>): column is DataColumn<T> => Boolean((column as DataColumn<T>).dataProperty);
